import * as yup from 'yup'

export const ResidencyTypeValidation = yup.string()
